"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMaxFee = exports.parseChainId = exports.BlockchainMap = exports.getIbcChainFromBlockchain = exports.ChainIdBlockchainMap = exports.totalAssetObj = exports.EmbedChainInfos = exports.makeIBCMinimalDenom = void 0;
const constant_1 = require("../constant");
const provider_1 = require("../provider");
const crypto_1 = require("@keplr-wallet/crypto");
const blockchain_1 = require("./blockchain");
// Create IBC minimal denom
function makeIBCMinimalDenom(sourceChannelId, coinMinimalDenom) {
    const sourceChannelIdProcess = sourceChannelId.indexOf("transfer/") === 0
        ? sourceChannelId.split("/").splice(1).join("/")
        : sourceChannelId;
    return ('ibc/' +
        Buffer.from(crypto_1.Hash.sha256(Buffer.from(`transfer/${sourceChannelIdProcess}/${coinMinimalDenom}`)))
            .toString('hex')
            .toUpperCase());
}
exports.makeIBCMinimalDenom = makeIBCMinimalDenom;
;
exports.EmbedChainInfos = Object.values(constant_1.EmbedChainInfosInit).reduce((prev, chainInfo) => {
    var _a;
    if (constant_1.swthIbcWhitelist.includes(chainInfo.chainId)) {
        const chainChannels = constant_1.swthChannels[chainInfo.chainId];
        chainInfo.currencies.push(Object.assign(Object.assign({}, provider_1.KeplrAccount.SWTH_CURRENCY), { coinMinimalDenom: makeIBCMinimalDenom((_a = chainChannels === null || chainChannels === void 0 ? void 0 : chainChannels.dstChannel) !== null && _a !== void 0 ? _a : "channel-0", provider_1.KeplrAccount.SWTH_CURRENCY.coinMinimalDenom) }));
    }
    prev[chainInfo.chainId] = chainInfo;
    return prev;
}, {});
exports.totalAssetObj = Object.values(exports.EmbedChainInfos).reduce((prev, chainInfo) => {
    if (!constant_1.ibcWhitelist.includes(chainInfo.chainId))
        return prev;
    const newAssetObj = prev;
    const assetsObj = {};
    const channelsObj = constant_1.swthChannels[chainInfo.chainId];
    chainInfo.currencies.forEach((currency) => {
        var _a;
        const ibcAddr = currency.coinDenom.toLowerCase() === "swth"
            ? currency.coinMinimalDenom
            : makeIBCMinimalDenom((_a = channelsObj === null || channelsObj === void 0 ? void 0 : channelsObj.sourceChannel) !== null && _a !== void 0 ? _a : "channel-0", currency.coinMinimalDenom);
        assetsObj[ibcAddr] = currency;
    });
    newAssetObj[chainInfo.chainId] = assetsObj;
    return newAssetObj;
}, {});
exports.ChainIdBlockchainMap = {
    [constant_1.ChainIds.Osmosis]: blockchain_1.Blockchain.Osmosis,
    [constant_1.ChainIds.Terra]: blockchain_1.Blockchain.Terra,
    [constant_1.ChainIds.CosmosHub]: blockchain_1.Blockchain.CosmosHub,
    [constant_1.ChainIds.Juno]: blockchain_1.Blockchain.Juno,
    [constant_1.ChainIds.Evmos]: blockchain_1.Blockchain.Evmos,
    [constant_1.ChainIds.Axelar]: blockchain_1.Blockchain.Axelar,
};
const getIbcChainFromBlockchain = (blockchain) => {
    let ibcChain = undefined;
    Object.entries(exports.ChainIdBlockchainMap).forEach(([key, value]) => {
        if (blockchain && blockchain.includes(value)) {
            ibcChain = key;
        }
    });
    return ibcChain;
};
exports.getIbcChainFromBlockchain = getIbcChainFromBlockchain;
exports.BlockchainMap = Object.values(exports.EmbedChainInfos).reduce((prev, chainInfo) => {
    if (!constant_1.ibcWhitelist.includes(chainInfo.chainId)) {
        return prev;
    }
    const newPrev = prev;
    const channelsObj = constant_1.swthChannels[chainInfo.chainId];
    chainInfo.currencies.forEach((currency) => {
        var _a;
        if (currency.coinDenom.toLowerCase() === "swth") {
            newPrev[currency.coinMinimalDenom] = exports.ChainIdBlockchainMap[chainInfo.chainId];
        }
        else {
            const ibcAddr = makeIBCMinimalDenom((_a = channelsObj === null || channelsObj === void 0 ? void 0 : channelsObj.sourceChannel) !== null && _a !== void 0 ? _a : "channel-0", currency.coinMinimalDenom);
            newPrev[ibcAddr] = exports.ChainIdBlockchainMap[chainInfo.chainId];
        }
    });
    return newPrev;
}, {});
const parseChainId = (chainId) => {
    var _a, _b;
    const chainArr = chainId.match(constant_1.ibcNetworkRegex);
    return {
        identifier: (_a = chainArr === null || chainArr === void 0 ? void 0 : chainArr[1]) !== null && _a !== void 0 ? _a : "",
        version: parseInt((_b = chainArr === null || chainArr === void 0 ? void 0 : chainArr[2]) !== null && _b !== void 0 ? _b : '0'),
    };
};
exports.parseChainId = parseChainId;
const calculateMaxFee = (gasStep = constant_1.DefaultGasPriceStep, gas = 0) => {
    return gasStep.high * gas;
};
exports.calculateMaxFee = calculateMaxFee;
